export default __webpack_public_path__ + "static/leo-6676914bc9228155c33aa36a4b9e7c9d.webp";